import Vue from 'vue';
import VueRouter from 'vue-router';
import Start from '../views/Start';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Start',
    component: Start,
  },
  {
    path: '/artists',
    name: 'Artists',
    component: () =>
      import(/* webpackChunkName: "Artists" */ '../views/Artists'),
  },
  {
    path: '/haxan',
    name: 'Haxan',
    component: () => import(/* webpackChunkName: "Haxan" */ '../views/Haxan'),
  },
  {
    path: '/kora-winter',
    name: 'Kora Winter',
    component: () =>
      import(/* webpackChunkName: "Kora Winter" */ '../views/KoraWinter'),
  },
  {
    path: '/shop',
    name: 'Shop',
    beforeEnter() {
      window.location.href = "https://aufewigwinter.bandcamp.com/";
    }
  },
  {
    path: '/legal-notice',
    name: 'Legal Notice',
    component: () =>
      import(/* webpackChunkName: "Legal Notice" */ '../views/LegalNotice'),
  },
  {
    path: '/tour',
    name: 'Tour Dates',
    component: () =>
        import(/* webpackChunkName: "Tour Dates" */ '../views/Tour'),
  },
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

export default router;
